module.exports = __webpack_public_path__ + "static/media/segunda_imagen.5fdda81a.png";